import { render, staticRenderFns } from "./TableWidget.vue?vue&type=template&id=1be1bc31&scoped=true"
import script from "./TableWidget.vue?vue&type=script&lang=ts"
export * from "./TableWidget.vue?vue&type=script&lang=ts"
import style0 from "./TableWidget.vue?vue&type=style&index=0&id=1be1bc31&prod&lang=scss&scoped=true"
import style1 from "./TableWidget.vue?vue&type=style&index=1&id=1be1bc31&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be1bc31",
  null
  
)

export default component.exports